import { SvgIcon } from "@mui/material";

const SvgToIcon = ({
  IconLogo,
  width = "24px",
  height = "auto",
  style = {},
  children = null,
}) => {
  return (
    <SvgIcon
      component={IconLogo}
      sx={{ width: width, height: height, ...style }}
      inheritViewBox
    >
      {children}
    </SvgIcon>
  );
};

export default SvgToIcon;
